<template>
  <div class="userCrowd">
    <div class="content">
      
    </div>
  </div>
</template>

<script>
export default {
  name: "userCrowd", // 用户分群
  data() {
    return {

    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.userCrowd {
  margin: 16px;
  background: #fff;
  .content {
    padding: 16px;

  }
}
</style>

<style lang="scss">
.userCrowd {
  .el-table th, .el-table tr {
    background: #f2f2f2;
  }
}
</style>
